// «Паспорт» сайта для SEO: адрес, бренд, картинки, реквизиты для schema.org.
// Модуль импортируют и клиент (RouteSeo), и пререндер (scripts/prerender.mjs
// через entry-server), никакого DOM/window здесь быть не должно.

export const SITE_URL = 'https://resstro.ru';
export const SITE_NAME = 'Resstro';
export const SITE_LOCALE = 'ru_RU';

/** OG-картинки 1200×630, генерируются `npm run og` (scripts/og-image.mjs) в public/og/. */
export const OG_IMAGE_SIZE = { width: 1200, height: 630 } as const;
export const DEFAULT_OG_IMAGE = '/og/resstro.png';

/** Публичный тариф: 2 500 ₽/мес за заведение (backend/src/shared/plans/catalog.ts → `single`). */
export const PRICE_FROM_RUB = 2500;
/** Триал ресторана, 7 дней (SIGNUP_TRIAL_DAYS на проде). */
export const TRIAL_DAYS = 7;
/** Поставщик и оптовик: 3 дня, затем 2 999 ₽/мес (catalog.ts → SUPPLIER_PLAN / WHOLESALER_PLAN). */
export const PARTNER_TRIAL_DAYS = 3;
export const PARTNER_PRICE_RUB = 2999;

export const CONTACTS = {
  supportEmail: 'resstrosaas@mail.ru',
  generalEmail: 'admin@resstro.ru',
  /** Формат E.164-подобный, как рекомендует schema.org. */
  phone: '+7-989-473-43-22',
  whatsapp: 'https://wa.me/79894734322',
  telegram: 'https://t.me/resstrosaas',
} as const;

export const LEGAL_ENTITY = {
  name: 'ИП Раджабов Рустам Эфлетдинович',
  founder: 'Раджабов Рустам Эфлетдинович',
  inn: '051707862851',
  region: 'Республика Дагестан',
} as const;
